import type { Observable } from 'rxjs/Observable';
import { fetchJson$ } from '@atlassian/jira-servicedesk-common/src/utils/fetch/index.tsx';
import {
	type QueueId,
	fromQueueId,
} from '@atlassian/jira-servicedesk-queues-common/src/model/index.tsx';
// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (projectKey: string, queueId: QueueId): Observable<void> => {
	const queueIdStr = fromQueueId(queueId).toString();

	const params = new URLSearchParams();
	params.set('queueId', queueIdStr);
	params.set('operation', 'fetchQueuesHistory');
	const url = `/rest/servicedesk/1/servicedesk/${projectKey}/queues-history?${params.toString()}`;

	return fetchJson$(url, { method: 'POST' });
};
